module.exports = __webpack_public_path__ + "static/media/golfer-7-a.5e5e5343.png";